import { StyleSheet } from "react-native";
import { theme } from "../../../../theme";
export const styles = StyleSheet.create({
    default: {
        ...theme.fontDefaults.large,
        fontFamily: "Proxima",
        backgroundColor: theme.colors.light.base,
        borderRadius: theme.spacing.xsmall2,
    },
    loading: {
        backgroundColor: theme.colors.greyscale.light,
    },
    row: {
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
    },
    item: {
        padding: theme.spacing.small,
        borderBottomWidth: 1,
        borderBottomColor: theme.colors.greyscale.lightest,
    },
    lastItem: {
        borderBottomWidth: 0,
    },
    topBorder: {
        borderTopWidth: 1,
        borderTopColor: theme.colors.greyscale.lightest,
    },
    searchBarContainer: {
        position: "relative",
    },
    searchIconContainer: {
        position: "absolute",
        zIndex: 10,
        right: theme.spacing.xsmall2,
        opacity: 0.15,
        height: "100%",
        justifyContent: "center",
    },
    tick: {
        position: "absolute",
        right: 0,
    },
    optionText: {
        paddingRight: theme.spacing.large,
    },
});
//# sourceMappingURL=InputList.styles.js.map